/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Actor { 
    type?: ActorTypeEnum;
    user_id?: string;
    snapshot?: string;
}
export enum ActorTypeEnum {
    CITTADINO = 'CITTADINO',
    OPERATORE = 'OPERATORE',
    SISTEMA = 'SISTEMA',
    ESTERNO = 'ESTERNO',
    CASSIERE = 'CASSIERE',
    ESERCENTE = 'ESERCENTE'
};



